import React from 'react';

export default function Footer() {
    return (
        <footer className="bg-[#003545] text-white text-right py-4">
            <div className="px-4">
                <p className="text-[14px] leading-[1.6]">&copy; Copyright {new Date().getFullYear()} - Schotpoort Connect</p>
            </div>
        </footer>
    );
}
